import memoizeOne from 'memoize-one';
import type { TimelineDuration } from '../../../../../model/timeline';
import { getTotalMilliseconds } from '../../../../../utils/timeline';

// Given the date range of the timeline, get the relative position of the date
export const getPosition = memoizeOne(
	(date: Date, timelineDuration: TimelineDuration): number =>
		// @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
		((date - timelineDuration.startDate) / getTotalMilliseconds(timelineDuration)) * 100,
);
